import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectGameConfig } from "src/store/common"
import useFogPreview from "src/hooks/useFogPreview"
import { saveFogPreview } from "src/utils/fogPreview"

import "./FogPreviewToggle.css"

/* Shown only when the server runs without fog (a testing setup): lets the tester see the map as a
   player would, redacted by the server itself. Absent on a real server — there, every view is
   already the real one and there is nothing to preview. */
const FogPreviewToggle = () => {
  const { t } = useTranslation()
  const gameConfig = useSelector(selectGameConfig)
  const enabled = useFogPreview()

  if (!gameConfig?.disable_fog_of_war) return null

  return (
    <div className="fog-preview">
      <div className="fog-preview-head">
        <span className="section-label">{t("settings.fogPreview")}</span>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          className={`fog-preview-switch${enabled ? " on" : ""}`}
          onClick={() => saveFogPreview(!enabled)}
        >
          {enabled ? t("settings.fogPreviewOn") : t("settings.fogPreviewOff")}
        </button>
      </div>
      <p className="p-mini fog-preview-help">{t("settings.fogPreviewHelp")}</p>
    </div>
  )
}

export default FogPreviewToggle
